// extracted by mini-css-extract-plugin
export var jumbotronBackground = "v3-module--jumbotronBackground--278oc";
export var hackaway3logoClass = "v3-module--hackaway3logoClass--3Ic2H";